(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["getman-category-entry"] && !Shopify.designMode) return;
  try {
    
  class GmCategoryEntry extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('[data-gm-cat-entry-row]');
      this.prevBtn = this.querySelector('[data-gm-cat-entry-prev]');
      this.nextBtn = this.querySelector('[data-gm-cat-entry-next]');
      if (!this.row || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', () => this.scrollByStep(-1));
      this.nextBtn.addEventListener('click', () => this.scrollByStep(1));
      this.row.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      window.addEventListener('load', () => this.updateArrows());

      this.updateArrows();
    }

    scrollByStep(direction) {
      const item = this.row.querySelector('.gm-cat-entry__item');
      const gap = parseFloat(getComputedStyle(this.row).columnGap || getComputedStyle(this.row).gap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : this.row.clientWidth * 0.8;
      this.row.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const maxScroll = this.row.scrollWidth - this.row.clientWidth - 1;
      const scrollable = this.row.scrollWidth - this.row.clientWidth > 2;
      this.row.classList.toggle('is-scrollable', scrollable);
      this.prevBtn.hidden = this.row.scrollLeft <= 0;
      this.nextBtn.hidden = this.row.scrollLeft >= maxScroll;
    }
  }

  customElements.define('gm-category-entry', GmCategoryEntry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getman-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  class GmNewArrivals extends HTMLElement {
    connectedCallback() {

      if (window.matchMedia('(min-width: 990px)').matches) {
        this.classList.add('gm-na--ready');
        return;
      }
      this.slides = Array.from(this.querySelectorAll('.gm-new-arrivals__slide'));
      this.dots = Array.from(this.querySelectorAll('.gm-new-arrivals__dot'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.interval = Math.max(1500, parseInt(this.dataset.interval, 10) || 3000);
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.classList.add('gm-na--ready');

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.dataset.goto, 10));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.touchX = null;
      this.touchY = null;
      this.addEventListener(
        'touchstart',
        (e) => {
          this.touchX = e.touches[0].clientX;
          this.touchY = e.touches[0].clientY;
          this.stop();
        },
        { passive: true }
      );
      this.addEventListener(
        'touchend',
        (e) => {
          if (this.touchX === null) return;
          const dx = e.changedTouches[0].clientX - this.touchX;
          const dy = e.changedTouches[0].clientY - this.touchY;
          this.touchX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            dx < 0 ? this.next() : this.go(this.index - 1);
          }
          this.start();
        },
        { passive: true }
      );

      this.io = new IntersectionObserver((entries) => {
        entries[0].isIntersecting ? this.start() : this.stop();
      });
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
    }

    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => {
        const active = n === this.index;
        s.classList.toggle('is-active', active);
        if (active) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));
    }

    next() {
      this.go(this.index + 1);
    }

    start() {
      if (this.timer || this.reduce) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('gm-new-arrivals')) {
    customElements.define('gm-new-arrivals', GmNewArrivals);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      requestAnimationFrame(() => this.setHeaderHeight());
      window.addEventListener('load', this.setHeaderHeight);
      window.addEventListener('resize', this.setHeaderHeight);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.setHeaderHeight());
      }

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      const ann = document.querySelector('.gm-announcement-section');
      document.documentElement.style.setProperty('--gm-ann-h', `${ann ? ann.offsetHeight : 0}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('load', this.setHeaderHeight);
      window.removeEventListener('resize', this.setHeaderHeight);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (document.body.classList.contains('overflow-hidden') || document.body.style.position === 'fixed') return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
